import { ReactNode } from 'react';

export type HRISConnectorType = 'WORKDAY';
type TeamConnectorState = 'ACTIVE' | 'NONE';

export type TransitionTo = 'TO_MEMBER_INVITE' | 'TO_DELETED' | 'TO_ORG_ADMIN_MANAGED';
export enum HRISFlowStep {
	CONNECT_HRIS,
	SYNC_TEAMS,
	COMPLETED,
}

export type Connector = {
	id: string;
	name: string;
	type: HRISConnectorType;
	siteId: string;
	state: TeamConnectorState;
};

export interface HRISStepItem {
	id: HRISFlowStep;
	title: string;
	description?: string;
	actions: ReactNode;
}

export interface HRISStepItemProps extends HRISStepItem {
	isCompleted: boolean;
	isCurrentStep: boolean;
}

export type State = {
	availableConnectors: Connector[];
	activeConnector: Connector | null;
	isLoading: boolean;
	error: Error | null;
	isInitializing: boolean;
	isInitialized: boolean;
	currentStep: HRISFlowStep;
	transitionTo: TransitionTo;
};

export type ModalOptions = {
	connector: Connector;
	onConfirm: () => Promise<void>;
};

export type ModalProps = ModalOptions & {
	onClose: () => void;
};

export type DisconnectOptionProps = {
	value: TransitionTo;
	title: string;
	description: string;
	isChecked: boolean;
	onChange: (value: TransitionTo) => void;
};
